import { render, staticRenderFns } from "./PostThumbnail.vue?vue&type=template&id=4fe1c73c&"
import script from "./PostThumbnail.vue?vue&type=script&lang=js&"
export * from "./PostThumbnail.vue?vue&type=script&lang=js&"
import style0 from "./PostThumbnail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports